import React from 'react';
import { Trans, withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import stepIcon from 'src/public/img/undraw-to-do-list.svg';

import { AppState } from 'src/config/appState';
import { redirectToUrl } from 'src/modules/navigation/actions/navigationActions';
import { ProgramEnum, ProgramWeekEnum } from 'src/modules/programs/models/programs';
import * as S from 'src/modules/programs/stepComponents/styles';
import { fetchSeveralProgramSurveys } from 'src/modules/programs/surveys/actions/surveysActions';
import { AnswersBySurveysIds } from 'src/modules/programs/surveys/models/surveys';
import { getSurveysAnswersBySurveysIds } from 'src/modules/programs/surveys/selectors/surveysSelectors';

import { PlannedExposures } from '../components/PlannedExposuresContent';
import { CBTProgramWeekSevenStep, CBTProgramWeekSevenSurvey } from '../models/weekSeven';

const surveysIds = [
    CBTProgramWeekSevenSurvey.PickAnExposure1,
    CBTProgramWeekSevenSurvey.PickAnExposure2,
];

interface StateProps {
    prevStepAnswersBySurveysIds: AnswersBySurveysIds | undefined;
}

interface ActionsProps {
    redirectToUrl: typeof redirectToUrl;
    fetchSeveralProgramSurveys: typeof fetchSeveralProgramSurveys;
}

interface Props extends ActionsProps, WithTranslation, StateProps {
    programId: ProgramEnum;
}

class ExposuresPracticeStepContainer extends React.Component<Props> {
    public componentDidMount(): void {
        const { programId } = this.props;

        this.props.fetchSeveralProgramSurveys({
            programId,
            surveysIds,
        });
    }

    private redirectToPickAnExposureStep = () => {
        const { programId } = this.props;

        const weekId = ProgramWeekEnum.WeekSeven;

        const stepId = CBTProgramWeekSevenStep.PickAnExposureStep;

        this.props.redirectToUrl(`/programs/${programId}/${weekId}/${stepId}`);
    };

    public render(): JSX.Element | null {
        const { t, prevStepAnswersBySurveysIds } = this.props;

        return prevStepAnswersBySurveysIds ? (
            <S.ContentRow>
                <S.ContentColumn md={14}>
                    <S.StepHeading small>{t('week-7.exposures-practice.heading')}</S.StepHeading>
                    <S.StepHeading>{t('week-7.exposures-practice.title')}</S.StepHeading>
                    <S.StepDescription small>
                        {t('week-7.exposures-practice.description')}
                    </S.StepDescription>
                    <S.PlannedActivitiesHolder>
                        <S.PlannedActivitiesHeading>
                            {t('week-7.exposures-practice.plannedActivities.heading')}
                        </S.PlannedActivitiesHeading>
                        <PlannedExposures answersBySurveysIds={prevStepAnswersBySurveysIds} />
                        <S.PlannedActivity smallPadding>
                            <S.ActivityContent>
                                {t('week-7.exposures-practice.plannedActivities.activity')}
                            </S.ActivityContent>
                        </S.PlannedActivity>
                    </S.PlannedActivitiesHolder>
                    <S.StepDescription small>
                        <Trans i18nKey="week-7.exposures-practice.changeExposure">
                            Back to previous screen to change your
                            <S.StyledLink onClick={this.redirectToPickAnExposureStep}>
                                Exposure
                            </S.StyledLink>
                            .
                        </Trans>
                    </S.StepDescription>
                </S.ContentColumn>
                <S.ContentColumn md={10}>
                    <S.StepIcon large iconUrl={stepIcon} />
                </S.ContentColumn>
            </S.ContentRow>
        ) : null;
    }
}

const mapStateToProps = (state: AppState, { programId }: Props): StateProps => ({
    prevStepAnswersBySurveysIds: getSurveysAnswersBySurveysIds(state, programId, surveysIds),
});

export const ExposuresPracticeStep = withTranslation('cbt')(
    connect(mapStateToProps, { redirectToUrl, fetchSeveralProgramSurveys })(
        ExposuresPracticeStepContainer,
    ),
);
